import { ArticleType } from '@/services/types/article.type';

// 매핑 객체
export const ArticleTypeKorean: Record<ArticleType, string> = {
  [ArticleType.FAQ]: '자주 묻는 질문',
  [ArticleType.NOTICE]: '공지사항',
  [ArticleType.EVENT]: '이벤트',
  [ArticleType.STORY]: '운전이야기',
  [ArticleType.BLOG]: '운전면허 블로그',
  [ArticleType.LICENSE_PROCESS]: '운전면허 취득 정보',
  [ArticleType.TEST_COURSE_ANALYSIS]: '시험장 코스분석',
  [ArticleType.TEST_COURSE_ROAD_ANALYSIS]: '시험장 도로주행 코스분석',
  [ArticleType.TEST_COURSE_SKILL_ANALYSIS]: '시험장 장내기능 코스분석',
};
export function getArticleTypeKorean(type: ArticleType): string {
  return ArticleTypeKorean[type];
}
